import { useTranslation } from 'react-i18next'
import { memo, useMemo } from 'react'
import { Badge, BadgeProps } from '@/components/ui/badge'
import { DirectCostsApproach, DirectCostScenario, DirectCostsGranularity } from '../api/types'

export type CogsBadgeOptions = DirectCostsApproach | DirectCostsGranularity | 'detailed_feature'

export const CogsBadge = memo((props: BadgeProps & { type: CogsBadgeOptions }) => {
  const { t } = useTranslation(`cogs`)
  return <Badge {...props}>{t(`cogs.periods.direct_costs.labels.${props.type}`)}</Badge>
})

export const BadgesByScenario = memo(({ scenario }: { scenario: DirectCostScenario }) => {
  const typesByScenario = useMemo(
    () => ({
      1: [`aggregate`, `absolute_value`] as CogsBadgeOptions[],
      2: [`aggregate`, `cost_per_unit`] as CogsBadgeOptions[],
      3: [`by_product`] as CogsBadgeOptions[],
      4: [`aggregate`, `percentage_of_revenues`] as CogsBadgeOptions[]
    }),
    []
  )
  return (
    <div className='flex items-center gap-2'>
      {typesByScenario[scenario].map(type => (
        <CogsBadge key={type} type={type} size='md' variant='info' />
      ))}
    </div>
  )
})
